<template>
  <div
    class="p-site-keyword-analysis-form p-site-keyword-analysis-form--keyword"
  >
    <div class="p-site-keyword-analysis-form__header">
      <Icon variant="sitekeywordanalysis" :size="16" radius />
      <h3 class="p-site-keyword-analysis-form__title">
        選択中のキーワードを「検索順位チェック」に登録する
      </h3>
    </div>
    <div class="p-site-keyword-analysis-form__content">
      <div class="c-alertPos">
        <Button
          variant="main"
          fsize="f14"
          icon="plus"
          class="l-w-290 l-pr-4"
          :class="{ 'is-loading': isProcessing }"
          :disabled="!count || isProcessing || isSubmitted"
          @click="submit"
        >
          検索順位チェックのキーワードに追加
        </Button>
        <Alert v-if="errorResponses.length">
          {{ errorResponses[0] }}
        </Alert>
      </div>
    </div>
  </div>
</template>

<script>
import { USAGE_LABEL, USAGE_COUNT_LABEL } from '@/constants';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Icon from '@/components/Icon';
import apiProjects from '@/api/projects';

export default {
  props: {
    count: {
      type: Number,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    Alert,
    Button,
    Icon
  },
  data() {
    return {
      errorResponses: [],
      usages: {
        rest: 0
      },
      isOver: false,
      isProcessing: false,
      isSubmitted: false
    };
  },
  watch: {
    count: {
      handler() {
        this.resetError();
        this.isSubmitted = false;
      }
    }
  },
  methods: {
    getUsages() {
      return Promise.all([this.getUsagesKeywords(), this.getUsagesCount()]);
    },
    getUsagesKeywords() {
      const params = {
        items: 'observation-keywords'
      };
      return apiProjects.usages.get(params, this.auth.idToken, this.project.id);
    },
    getUsagesCount() {
      const params = {
        items: 'observation-keywords'
      };
      return apiProjects.usages.count.get(
        params,
        this.auth.idToken,
        this.project.id
      );
    },
    submit() {
      if (this.isProcessing) {
        return;
      }
      this.isProcessing = true;
      this.errorResponses = [];

      // 利用量を取得
      this.getUsages()
        .then(response => {
          const count = this.items.length; //登録したい数
          const usages = response[0].data.items[0]; //登録数
          const usagesCount = response[1].data; //登録回数
          const usagesRest = usages.max - usages.current;
          const usagesRestCount = usagesCount.max - usagesCount.current;

          if (usagesCount.current + count > usagesCount.max) {
            this.errorResponses.push(
              `${USAGE_COUNT_LABEL['observation-keywords']}の上限に達しています。今月登録できるのは残り${usagesRestCount}件です。`
            );
          } else if (usages.current + count > usages.max) {
            this.errorResponses.push(
              `${USAGE_LABEL['observation-keywords']}の上限に達しています。登録できるのは${usagesRest}件までです。`
            );
          }
          if (this.errorResponses.length) {
            this.isProcessing = false;
            return;
          }

          Promise.all(
            this.items.map(item => {
              return this.postKeyword(item);
            })
          )
            .then(response => {
              this.isProcessing = false;
              this.isSubmitted = true;
            })
            .catch(error => {
              this.isProcessing = false;
            });
        })
        .catch(error => {
          if (error.response) {
            this.errorResponses = [error.response.data.errors[0].userMessage];
          }
          this.isProcessing = false;
        });
    },
    async postKeyword(item) {
      let params = {
        keyword: item.keyword,
        url: item.url
      };
      let hasError = false;

      // キーワードIDが既に存在する場合は処理をスキップする
      const keywordId = await apiProjects.observationKeywords.search
        .get(params, this.auth.idToken, this.project.id)
        .then(response => response.data.id)
        .catch(error => {
          if (error.response.status === 404) {
            return null;
          } else {
            this.errorResponses.push(error.response.data.errors[0].userMessage);
            hasError = true;
            return null;
          }
        });

      if (keywordId || hasError) {
        return;
      } else {
        return apiProjects.observationKeywords
          .post(params, this.auth.idToken, this.project.id)
          .then(response => {})
          .catch(error => {
            if (error.response) {
              this.errorResponses.push(
                error.response.data.errors[0].userMessage
              );
            }
          });
      }
    },
    resetError() {
      if (!this.isOver || this.usages.rest >= this.count) {
        this.errorResponses = [];
        this.isOver = false;
      }
    }
  }
};
</script>
